import React from 'react';
import Navbar from './Navbar';
import DashboardCards from './DashboardCards';

const Content = ({ children, currentPage, showCards = true, stats, className }) => {
  return (
    <div className={`user-dashboard__content flex-grow-1 ${className}`}>
      <Navbar currentPage={currentPage} />
      {showCards && <DashboardCards stats={stats} />}
      {children}
    </div>
  );
};

export default Content;
